import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import areaApi from 'api/areaApi';
import miscApi from 'api/miscApi';
import permissionApi from 'api/permissionApi';
import _ from 'lodash';

// MARK: --- Thunks ---
// lay danh sach cay khu vuc
export const thunkGetAreaTree = createAsyncThunk(
  'app/thunkGetAreaTree',
  async (params, thunkAPI) => {
    const res = await areaApi.getAreaList(params);
    return res;
  }
);

// lay app config
export const thunkGetAppConfig = createAsyncThunk(
  'app/thunkGetAppConfig',
  async (params, thunkAPI) => {
    const res = await miscApi.getConfig();
    return res;
  }
);

// lay ds banks
export const thunkGetBankList = createAsyncThunk(
  'app/thunkGetBankList',
  async (params, thunkAPI) => {
    const res = await miscApi.getBankList();
    return res;
  }
);

// lay ds quyen
export const thunkGetPermissionList = createAsyncThunk(
  'app/thunkGetPermissionList',
  async (params, thunkAPI) => {
    const res = await permissionApi.getPermissionList();
    return res;
  }
);

const initialState = {
  areaTree: {},
  appConfig: {},
  bankList: [],
  permissionList: [],
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {},
  extraReducers: {
    [thunkGetAreaTree.pending]: (state, action) => {},
    [thunkGetAreaTree.rejected]: (state, action) => {},
    [thunkGetAreaTree.fulfilled]: (state, action) => {
      const { result, tree } = action.payload;
      if (result === 'success') {
        state.areaTree = tree ?? {};
      }
    },

    // app config
    [thunkGetAppConfig.pending]: (state, action) => {},
    [thunkGetAppConfig.rejected]: (state, action) => {},
    [thunkGetAppConfig.fulfilled]: (state, action) => {
      const { result, config, operators, services } = action.payload;
      if (result === 'success') {
        state.appConfig['config'] = config;
        state.appConfig['operators'] = operators;
        state.appConfig['services'] = services;
      }
    },

    // bank list
    [thunkGetBankList.fulfilled]: (state, action) => {
      const { code, data } = action.payload;
      if (data && _.isArray(data)) {
        state.bankList = data;
      }
    },

    // permission list
    [thunkGetPermissionList.pending]: (state, action) => {},
    [thunkGetPermissionList.rejected]: (state, action) => {},
    [thunkGetPermissionList.fulfilled]: (state, action) => {
      const { result, permissionGroups } = action.payload;
      if (result === 'success') {
        state.permissionList = permissionGroups ?? [];
      }
    },
  },
});

const { reducer, actions } = appSlice;
export const {} = actions;
export default reducer;
